// removed by extract-text-webpack-plugin
module.exports = {"root":"_2NBXi","slider":"xdM8b","pitValue":"_1oTvv","pitMarker":"_3Ve2J","pitContainer":"_24PKT","pitMarkerSelected":"_3Y9-Z"};